// src/views/ReemplazosView.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../apiConfig";

export default function ReemplazosView() {
  const [equipos, setEquipos] = useState([]);
  const [filtro, setFiltro] = useState("TODOS");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cargar = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE}/inventario`);
        const lista = res.data || [];
        console.log("DATA INVENTARIO → ", lista);


        // 🔥 Mantener en null los equipos que no tienen estatusReemplazo
        const conReemplazo = lista.map((e) => ({
          ...e,
          estatusReemplazo: e.estatusReemplazo ?? null,
        }));

        setEquipos(conReemplazo);
      } catch (err) {
        console.error("Error cargando inventario:", err);
        alert("No se pudo cargar el inventario");
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, []);

  // 🔎 FILTROS
  const filtrarEquipos = () => {
    // 👉 "TODOS" debe mostrar solo equipos con prioridad (NO los OK)
    if (filtro === "TODOS") {
      return equipos.filter(
        (e) =>
          e.estatusReemplazo &&
          e.estatusReemplazo !== "OK" &&
          e.estatusReemplazo !== null
      );
    }

    // 👉 Filtros individuales
    return equipos.filter((e) => e.estatusReemplazo === filtro);
  };

  const visibles = filtrarEquipos();

  const getBadgeClass = (estatus) => {
    switch (estatus) {
      case "URGENTE":
        return "bg-rose-100 text-rose-700 border-rose-200";
      case "REEMPLAZO":
        return "bg-amber-100 text-amber-700 border-amber-200";
      case "ADVERTENCIA":
        return "bg-yellow-100 text-yellow-700 border-yellow-200";
      default:
        return "bg-emerald-100 text-emerald-700 border-emerald-200";
    }
  };

  return (
    <div className="w-full min-h-screen bg-slate-100 flex justify-center py-8 px-4">
      <div className="w-full max-w-6xl bg-white rounded-3xl shadow-[0_18px_50px_rgba(15,23,42,0.18)] border border-slate-100 p-6 sm:p-8">
        
        {/* ENCABEZADO */}
        <header className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6 border-b border-slate-100 pb-4">
          <div>
            <p className="text-[11px] font-semibold tracking-[0.28em] text-sky-500 uppercase mb-1">
              Inteligencia de reemplazo
            </p>
            <h1 className="text-2xl font-bold text-slate-900">
              Equipos a reemplazar
            </h1>
            <p className="text-xs text-slate-500 mt-1 max-w-xl">
              Visualiza los equipos priorizados por reemplazo con base en su antigüedad y estado operativo.
            </p>
          </div>

          {/* FILTROS */}
          <div className="flex flex-wrap gap-2">
            {["TODOS", "URGENTE", "REEMPLAZO", "ADVERTENCIA"].map((op) => (
              <button
                key={op}
                onClick={() => setFiltro(op)}
                className={
                  "px-3.5 py-1.5 rounded-full text-xs font-semibold border transition " +
                  (filtro === op
                    ? "bg-sky-500 text-white border-sky-500 shadow-sm"
                    : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50")
                }
              >
                {op === "TODOS" ? "Todos" : op}
              </button>
            ))}
          </div>
        </header>

        {/* TABLA */}
        <div className="overflow-x-auto rounded-2xl border border-slate-100">
          <table className="min-w-full text-xs">
            <thead className="bg-slate-50/80 text-slate-500">
              <tr>
                <th className="px-4 py-2 text-left font-medium">Equipo</th>
                <th className="px-4 py-2 text-left font-medium">Serie</th>
                <th className="px-4 py-2 text-left font-medium">Proyecto</th>
                <th className="px-4 py-2 text-left font-medium">Municipio</th>
                <th className="px-4 py-2 text-left font-medium">Oficina</th>
                <th className="px-4 py-2 text-left font-medium">Fecha adquisición</th>
                <th className="px-4 py-2 text-left font-medium">Estado operativo</th>
                <th className="px-4 py-2 text-left font-medium">Prioridad</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={8} className="px-4 py-6 text-center text-slate-400">
                    Cargando información...
                  </td>
                </tr>
              ) : visibles.length === 0 ? (
                <tr>
                  <td colSpan={8} className="px-4 py-6 text-center text-slate-400">
                    No hay equipos con el filtro seleccionado.
                  </td>
                </tr>
              ) : (
                visibles.map((e) => (
                  <tr key={e.id} className="border-t border-slate-100 hover:bg-slate-50/60">
                    <td className="px-4 py-2 text-slate-800 font-medium">
                      {e.equipo}{" "}
                      <span className="text-[11px] text-slate-400 block">
                        {e.marca} {e.modelo}
                      </span>
                    </td>
                    <td className="px-4 py-2 text-slate-600">{e.serie || "—"}</td>
                    <td className="px-4 py-2 text-slate-600">{e.proyecto || "—"}</td>
                    <td className="px-4 py-2 text-slate-600">{e.municipio || "—"}</td>
                    <td className="px-4 py-2 text-slate-600">{e.oficina || "—"}</td>
                    <td className="px-4 py-2 text-slate-600">
                      {e.fechaAdquisicion || "—"}
                    </td>
                    <td className="px-4 py-2 text-slate-600">
                      {e.estadoEquipo || "—"}
                    </td>
                    <td className="px-4 py-2">
                      <span
                        className={
                          "inline-flex items-center px-3 py-1 rounded-full border text-[11px] font-semibold " +
                          getBadgeClass(e.estatusReemplazo)
                        }
                      >
                        {e.estatusReemplazo}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
